import selectCompanyModalTemplate from '../../../../pages/auth/views/modals/selected-company-modal.tpl.html';

/**
 * @ngdoc object
 * @name theme.base.controller:HeaderCtrl
 *
 * @description
 *
 */

class LayoutHeaderCtrl {
    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.modal = this.injector.get('$uibModal');
        this.auth = this.injector.get('$auth');
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.locationService = this.injector.get('$location');
        this.currentLocation = this.locationService.path();
        this.state = this.injector.get('$state');
        this.rootScope = this.injector.get('$rootScope');
        this.timeout = this.injector.get('$timeout');
        this.navHelper = this.injector.get('NavHelper');
        this.posService = this.injector.get('PosService');
        this.usersStore = this.injector.get('Users');
        this.showNav = false;

        this.hasTabs = false;

        this.injector.get('$transitions').onStart({}, trans => {
            trans.promise.finally(() => {
                this.currentLocation = this.locationService.path();
            });
        });

        this.store = this.injector.get('Users');
        this.store.dispatch('getLoggedIn').then(() => {
            this.user = this.store.state.loggedin.profile;

            this.showNav = !!this.user;

            this._initSettings();
        });
        this.checkinMode = false;
        this.displayLastYear = (localStorage.getItem('display-last-year-bookings') === '1');

        this.scope.$watch(() => {
            return this.displayLastYear;
        }, (newValue) => {
            localStorage.setItem('display-last-year-bookings', (this.displayLastYear ? '1' : '0'));
            this.rootScope.displayLastYearBookings = this.displayLastYear;
            this.rootScope.$applyAsync();
        })

        this.navRootLevelElements = [];
        this.settingsElement = null;
        this.settingsSubElements = [];

        this.showMobSearch = false;
        this.showMobNotifications = false;
        this.showMobSettings = false;
    }

    $onInit() {
        this._registerEventListeners();

        if (!this.navHelper.isInitializing()) {
            this._updateRootNavElements();
            this._updateTabState();
        }
    }

    toggleCheckinMode() {
        this.store.dispatch('toggleCheckinMode', this.checkinMode);
    }

    switchCompany() {
        this.modal.open({
            controller: 'SelectCompanyModalController',
            controllerAs: 'vm',
            size: 'sm',
            templateUrl: selectCompanyModalTemplate,
            resolve: {
                availableCompanies: () => {
                    return this.store.state.loggedin.profile.available_companies;
                }
            }
        }).result.then((dataFromModal) => {
            const companyUidToSwitchTo = dataFromModal.selectedCompany.uid;

            this.api.post('auth/switch-company', {
                company_uid: companyUidToSwitchTo
            }).then((response) => {
                this.auth.setToken(_.get(response, 'data.data.token'));
                this.state.go('app.dashboard', {}).then(() => {
                    this.timeout(() => {
                        location.reload();
                    }, 400);
                });
            }, () => {
                this.alert.error('Error', 'Error while switching company');
            })
        }, (e) => {

        }).catch((e) => {
            this.alert.handle(e);
        });
    }

    _initSettings() {
        this.enableLastYearBookingsSwitch = _.get(this.store, 'state.company.settings.rsvps.enable_show_last_year_switch', false);
        this.enableCheckInModeSwitch = _.get(this.store, 'state.company.settings.rsvps.enable_show_last_year_switch', false);
    }

    _registerEventListeners() {
        this.rootScope.$on('al-navigation-updated', () => {
            this._updateTabState();
            this._updateRootNavElements();
        })
    }

    _updateTabState() {
        const currentNavState = this.navHelper.getCurrentNavigationElement();
        let currentTabElements = [];
        if (currentNavState) {
            let childElements = _.filter(
                this.navHelper.getChildrenByParentKey(currentNavState.key),
                (navElement) => {
                    return navElement.showInNavigation;
                }
            );
            if (childElements.length === 0 && currentNavState.parentKey) {
                childElements = this.navHelper.getChildrenByParentKey(currentNavState.parentKey)
            }
            currentTabElements = _.filter(childElements, (element) => {
                if (!element.showInNavigation) {
                    return false;
                }

                if (_.isFunction(element.customAccessor)) {
                    return element.customAccessor(this.injector);
                }

                return true;
            });
        }

        this.rootScope.hasTabs = currentNavState && !currentNavState.hideTabNav && currentTabElements.length > 0;
        this.rootScope.$applyAsync();
    }

    _updateRootNavElements() {
        this.settingsElement = this.navHelper.getElementByKey('root.settings');

        if (this.settingsElement) {
            this.settingsSubElements = _.filter(
                this.navHelper.getChildrenByParentKey(this.settingsElement.key),
                (navElement) => navElement.showInNavigation
            );
        }

        let currentNavElement = this.navHelper.getCurrentNavigationElement();

        this.navRootLevelElements = _.filter(this.navHelper.getRootNavInformation(), (element) => {
            return element.key !== 'root.settings'
                && (currentNavElement && currentNavElement.key !== 'root.settings')
                && (
                    (this.settingsElement.onPath || this.settingsElement.active)
                    || ((!currentNavElement || currentNavElement.level > 1) && !element.onPath && !element.active)
                )
        });
        this.fullRootNavElemnts = this.navHelper.getRootNavInformation();
        this.scope.$applyAsync();
    }

    handleRootElementClick(element) {
        this.navHelper.handleElementAction(element);
    }

    openPosModal($event) {
        this.posService.openPosModal();
        $event.target.blur();
    }
}


angular
    .module('festzelt-os.theme.festzelt-os')
    .controller('LayoutHeaderCtrl', [
        '$scope',
        '$injector',
        '$element',
        LayoutHeaderCtrl
    ]);




// WEBPACK FOOTER //
// ./src/app/theme/festzelt-os/components/header/controller.js